/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="walkinManagerSettings.base.section.ts" />

module Meevo.Plugins.WalkinManagerSettings {
    'use strict';

    import Service = Meevo.Model.Service;

    /**
     * WalkIn Services Section of Walkin Manager Settings
     */
    export class WalkInServicesSection extends Meevo.Plugins.WalkinManagerSettings.BaseSection {
        public services: Service[] = [];
        public selectedServices: Service[] = [];

        private _backup: Service[];
        private serviceWalkInCriteria = {
            itemsPerPage: 5000,
            criteria: {}
        };

        private get dataToSave() {
            return {
                serviceListBookableWalkIn: this.selectedServices === null ? [] : this.selectedServices.map((item) => item.id),
                selectAll: false
            };
        }

        public activate(): void {
            if (!this.isLoaded) {
                this.dataService.getListPaged('service', this.serviceWalkInCriteria).then((res) => {
                    this.services = res;
                    this.services.forEach((item) => item.displayName = item.shortcut + ': ' + item.displayName);
                    this.selectedServices = res.filter((item) => item.allowBookableWalkIn);
                });
            }

            super.activate();
        }

        takeBackup(): void {
            this._backup = angular.copy(this.selectedServices);
        }

        rollbackChanges(): void {
            this.selectedServices = angular.copy(this._backup);
        }

        public customSave(): ng.IPromise<any> {
            return this.dataService.customMethodData(`/api/Service/BookableWalkIn`, 'PATCH', this.dataToSave)
                .then((res) => {
                    this.services = res.data;
                    this.services.forEach((item) => item.displayName = item.shortcut + ': ' + item.displayName);
                    this.selectedServices = res.data.filter((item) => item.allowBookableWalkIn);
                });
        }
    }
}
